import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../app.settings';
import { Store } from '@ngxs/store';
import { DesignationActions } from '../transaction-store/designation';

@Component({
  selector: 'app-custom-notes',
  template: `
    <section class="container" *ngFor="let item of customNotes; let i = index">
      <div class="row" [ngSwitch]="item.mode">
        <text-field
          *ngSwitchCase="'free'"
          class="col-12"
          type="text"
          [(ngModel)]="item.value"
          [label]="item.label"
          (blur)="onNoteChange(item.id, item.label, $event)"
          [required]="item.required"
        ></text-field>
        <select-field
          *ngSwitchCase="'lookup'"
          class="col-12"
          [(ngModel)]="item.value"
          [label]="item.label"
          [items]="item.lookups"
          (blur)="onNoteChange(item.id, item.label, $event)"
          [required]="item.required"
          >{{ item.label }}</select-field
        >
        <select-field
          *ngSwitchCase="'lookup_free'"
          class="col-12"
          [(ngModel)]="item.value"
          [label]="item.label"
          [items]="item.lookups"
          (search)="searched(item, $event)"
          [searchable]="true"
          (blur)="comboSelectValue(item)"
          [required]="item.required"
        >
          {{ item.label }}
        </select-field>
      </div>
    </section>
    <section class="container" *ngIf="showP2pComment">
      <div class="row">
        <text-field
          class="col-12"
          type="text"
          [(ngModel)]="p2pFundraiserComment"
          [label]="'Comments'"
          (blur)="onCommentsChange($event)"
        >
        </text-field>
      </div>
    </section>
  `
})
export class CustomNotesComponent implements OnInit {
  customNotes = [];
  public p2pFundraiserComment = '';
  public showP2pComment = false;

  constructor(private settings: AppSettings, private store: Store) {
    const properties = this.settings.getValue('properties');
    this.customNotes = [1, 2, 3, 4, 5]
      .map(i => {
        const item = {
          id: i,
          label: properties['custom_note_label_' + i.toString()],
          mode: properties['custom_note_mode_' + i.toString()],
          lookups: properties['custom_note_lookups_' + i.toString()] || [],
          required: properties['custom_note_required_' + i.toString()] || false,
          comboUserInput: '',
          value: null
        };

        const value = properties['custom_note_' + i.toString()];
        item.value = value;
        if (item.mode === 'free' && !item.value) {
          item.value = ''; // selects need to be null to get the placeholder to show up correctly
        }

        return item;
      })
      .filter(item => !!item.label);
    if (properties.p2p_fundraiser_id) {
      this.showP2pComment = true;
    }
  }
  searched(note, term) {
    const items = note.lookups.filter(l => l !== note.comboUserInput);
    note.comboUserInput = term;

    if (items.indexOf(term) === -1 && typeof term === 'string') {
      items.push(term);
    }

    note.lookups = items;
  }
  ngOnInit() {
    this.customNotes.map(item =>
      item.value && item.value === ''
        ? this.onNoteChange(item.id, item.label, item.value)
        : true
    );
  }
  onNoteChange(index, label, value) {
    this.store.dispatch(
      new DesignationActions.SetNoteValue({
        index: index,
        value: `${label} = ${value}`
      })
    );
  }
  onCommentsChange($event) {
    this.store.dispatch(new DesignationActions.SetCommentsValue($event));
  }
  comboSelectValue(item) {
    // Clear user-added value if they select from the list
    if (item.value !== item.comboUserInput) {
      item.lookups = [...item.lookups.filter(l => l !== item.comboUserInput)];
    }

    this.onNoteChange(item.id, item.label, item.value);
  }
}
